'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 1220
// module chunks = 35783957827783